<section class="blog__home">
  <div class="container">
    <div class="row">
      <div class="encabezado">
        <h2 class="encabezado--h2">Blog</h2>
        <p class="encabezado--p">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis eget
          felis, in quisque libero in quis ut. Mi quam arcu.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="blog">
        <div class="blog__img"></div>
        <div class="blog__text">
          <h3 class="blog__text--h3">Lorem ipsum dolor sit</h3>
          <p class="blog__text--date">Febrero 26, 2021</p>
          <p class="blog__text--p">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla amet
            in nisl accumsan in fringilla tortor. Turpis urna nunc diam egestas
            vel, phasellus. Mauris duis nec venenatis, habitasse. Scelerisque
            phasellus integer sed bibendum vel amet eget egestas. Arcu nibh
            blandit fringilla volutpat. Egestas erat ut.
          </p>
          <button class="blog__text--btn">Read More</button>
        </div>
      </div>
    </div>
  </div>
</section>
